import {createWebHashHistory, createRouter} from "vue-router";
import LoginView from "@/src/views/LoginView.vue";
import HomeView from "@/src/views/HomeView.vue";
import GraphView from "@/src/views/graph/GraphView";
import RepoView from "@/src/views/repo/RepoView";
import OfflineView from "@/src/views/OfflineView";
import StatusView from "@/src/views/StatusView";
import UserManagementView from "@/src/views/user/UserManagementView.vue";
import SystemSettings from "@/src/views/system/SystemSettings.vue";

import store from "@/src/store";
import {auth} from "@/firebaseConfig";
import ChatBotAdminView from "@/src/views/chatbotAdmin/BaseView.vue";

export const ROUTE_NAMES = {
    HOME: "Home",
    REPO: "Repo",
    SPACE: "Space",
    GRAPH: "Graph",
    LOGIN: "Login",
    OFFLINE: "Offline",
    STATUS: "Status",
    USER_MANAGEMENT: "UserManagement",
    SETTINGS: "Settings",
};

const routes = [
    {
        path: "/",
        name: ROUTE_NAMES.HOME,
        component: HomeView,
        redirect: "/repo",
        children: [
            //these components are rendered inside a <router-view> nested in HomeView
            {
                path: "/graph",
                redirect: "/repo",
            },
            {
                path: "/repo/:spaceId?",
                name: ROUTE_NAMES.REPO,
                component: RepoView,
                props: true, // enable props to pass route params to the component
            },
            {
                path: "/graph/:graphId",
                name: ROUTE_NAMES.GRAPH,
                component: GraphView,
            },
            // need to add a redirect for backwards compatibility from url /repo/:spaceId/:graphId to /graph/:graphId
            {
                path: "/repo/:spaceId/:graphId",
                redirect: to => {
                    return {
                        name: ROUTE_NAMES.GRAPH,
                        params: {graphId: to.params.graphId},
                    };
                },
            }
        ],
    },

    {
        path: "/user-management",
        name: ROUTE_NAMES.USER_MANAGEMENT,
        component: UserManagementView,
        // should only be available for admin users
        // beforeEnter: (to, from, next) => {
        //     if (store.state.userStore.user && store.state.userStore.user.admin) {
        //         next()
        //     } else {
        //         next({name: 'Home'})
        //     }
        // }
    },
    {
        path: "/settings",
        name: ROUTE_NAMES.SETTINGS,
        component: SystemSettings,
    },
    {
        path: "/chatbotadmin",
        name: ROUTE_NAMES.CHATBOT_ADMIN,
        component: ChatBotAdminView,
    },
    {
        path: "/login",
        name: ROUTE_NAMES.LOGIN,
        component: LoginView,
    },
    {
        path: "/offline",
        name: ROUTE_NAMES.OFFLINE,
        component: OfflineView,
        beforeEnter: (to, from, next) => {
            if (from.name === "Offline" || typeof from.name === "undefined") {
                next({name: "Home"});
            }
            next();
        },
    },
    {
        path: "/status",
        name: ROUTE_NAMES.STATUS,
        component: StatusView,
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    localStorage.setItem(
        "FIREBASE_SSO_ENABLED",
        import.meta.env.VITE_FIREBASE_SSO_ENABLED
    );
    localStorage.setItem(
        "BASIC_AUTHENTICATION_ENABLED",
        import.meta.env.VITE_BASIC_AUTHENTICATION_ENABLED
    );
    localStorage.setItem("TENANT_ID", auth.tenantId);
    auth.onAuthStateChanged(user => {
        store.commit("userStore/setUser", user);
        if (to.name === ROUTE_NAMES.STATUS) {
            //always accessible
            next();
            return;
        }
        if (user && to.name === ROUTE_NAMES.LOGIN) {
            auth.currentUser
                .getIdToken(/* forceRefresh */ true)
                .then(async function (idToken) {
                    localStorage.setItem("ID_TOKEN", idToken);
                    localStorage.setItem("UID", auth.currentUser.uid);
                    await ssoBackendValidation(to.name, auth.currentUser.uid, idToken);
                    // adding redirect after login to make sure token is refreshed
                    const lastRoute = localStorage.getItem("lastRoute");
                    if (lastRoute) {
                        localStorage.removeItem("lastRoute");
                        await router.push(JSON.parse(lastRoute));
                    } else {
                        await router.push({name: ROUTE_NAMES.HOME});
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
        if (to.name !== ROUTE_NAMES.LOGIN && !user) {
            console.log("Router: redirect to login page, no sso user.");
            // save last url to redirect later in the login page
            localStorage.setItem("lastRoute", JSON.stringify(to));
            next({name: ROUTE_NAMES.LOGIN});
            return;
        }
        if (
            (to.name !== ROUTE_NAMES.LOGIN && user) ||
            (to.name === ROUTE_NAMES.LOGIN && !user)
        ) {
            next();
            return;
        }
    });
});

const ssoBackendValidation = async (to, uid, idToken) => {
    try {
        await store.dispatch("userStore/ssoBackendValidation", {
            uid: uid,
            id_token: idToken,
        });
    } catch (err) {
        console.log(err);
    }
};

export default router;
